<div>
  @if (label) {
    <label [for]="selectId" class="mb-1">{{label}}</label>
  }
  <div class="relative">
    <select #selectRef [id]="selectId" [name]="selectId" [ngClass]="extendClassStyles" class="select-dropdown" (change)="handleChange($event)" [disabled]="disabled" tabindex="0">
      @if (placeholder) {
        <option value="" disabled selected>{{isLoadingState ? isLoadingPlaceholder : placeholder }}
        </option>
      }
      @for (item of data; track item) {
        <option [value]="item.value" [selected]="item.value === defaultSelectedOption">{{ item.label
        }}</option>
      }
    </select>

    @if (!isLoadingState) {
      <span class="select-icon">
        @if (isLoadingState) {
          <loading-indicator label=""></loading-indicator>
        }
      </span>
    }
  </div>
</div>
